/* eslint-disable @typescript-eslint/no-explicit-any */
import toast from "react-hot-toast";

// for backward compatibility
export const useToast = () => {
  return { showMessage: toast }; // for backward compatibility
};
